import { render, staticRenderFns } from "./AdminXeroContactSupplierMatchingPage.vue?vue&type=template&id=fffb768e&scoped=true&"
import script from "./AdminXeroContactSupplierMatchingPage.vue?vue&type=script&lang=js&"
export * from "./AdminXeroContactSupplierMatchingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffb768e",
  null
  
)

export default component.exports